import IconError from '@apollo/icons/default/IconError.svg';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import { groupBy } from 'lodash';
import React from 'react';

import { Loading } from './loading/Loading';

export const ErrorModal = ({
  title,
  description,
  errors,
  isOpen,
  onClose,
  bottomLeftText,
  loading,
}: {
  title: React.ReactNode;
  description: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  errors: {
    group: string | null | undefined;
    code: string | null;
    message: string;
  }[];
  loading?: boolean;
  bottomLeftText?: React.ReactNode;
}) => {
  const errorGroups = groupBy(errors, (e) => e.group);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ModalDescription>{description}</ModalDescription>
        </ModalHeader>
        <ModalBody className="px-0">
          {loading ? (
            <div className="h-120">
              <Loading />
            </div>
          ) : (
            <div className="w-full flex-col items-center bg-red-lightest px-8 py-3">
              {Object.entries(errorGroups).map(([groupName, groupErrors]) => {
                return (
                  <div
                    className="mb-1.5 mt-0.5 flex-col items-center"
                    key={groupName}
                  >
                    {groupName && (
                      <div className="flex items-center">
                        <IconError className="text-icon-error [&_.inner]:fill-white" />
                        <span className="ml-2 text-base font-semibold text-red-darkest">
                          {groupName}
                        </span>
                      </div>
                    )}

                    {groupErrors.map(({ code, message }) => {
                      return (
                        <div
                          key={`${code}:${message}`}
                          className="my-2 ml-[9px] w-full flex-col justify-items-stretch border-l-2 border-red-lighter p-1 pl-4 font-mono text-xs text-red-darkest"
                        >
                          <p>{code}</p>
                          <p>{message}</p>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {bottomLeftText}
          <Button variant="primary" type="submit" onClick={onClose}>
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
